package components

import androidx.compose.runtime.*
import design.AccessibilityGuidelines
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import styles.AppStyleSheet

/**
 * Notification permission prompt modal component
 * Shows a custom modal to request push notification permission on first visit
 */
@Composable
fun NotificationPermissionPrompt(
    isVisible: Boolean,
    onEnable: () -> Unit,
    onLater: () -> Unit,
) {
    if (!isVisible) return

    // Set up focus trap when modal opens
    LaunchedEffect(Unit) {
        AccessibilityGuidelines.saveFocus()
        AccessibilityGuidelines.trapFocus("notification-prompt-modal")
    }

    Div({ classes(AppStyleSheet.modalOverlay) }) {
        Div({
            classes(AppStyleSheet.modalContent)
            id("notification-prompt-modal")
            attr("role", "dialog")
            attr("aria-modal", "true")
            attr("aria-labelledby", "notification-prompt-title")
            attr("aria-describedby", "notification-prompt-desc")
        }) {
            H2({
                id("notification-prompt-title")
                style {
                    fontSize(24.px)
                    marginBottom(16.px)
                    textAlign("center")
                }
            }) {
                Text("通知を受け取りますか？")
            }

            Div({
                style {
                    fontSize(48.px)
                    textAlign("center")
                    marginBottom(16.px)
                }
                attr("aria-hidden", "true")
            }) {
                Text("🔔")
            }

            P({
                id("notification-prompt-desc")
                style {
                    fontSize(14.px)
                    color(Color("#666"))
                    marginBottom(24.px)
                    lineHeight("1.5")
                }
            }) {
                Text("プッシュ通知を有効にすると、新しい投稿やコメントに関する通知を受け取ることができます。")
            }

            Div({
                style {
                    display(DisplayStyle.Flex)
                    gap(12.px)
                    justifyContent(JustifyContent.Center)
                }
            }) {
                Button({
                    classes(AppStyleSheet.primaryButton)
                    onClick {
                        onEnable()
                        AccessibilityGuidelines.releaseFocus()
                        AccessibilityGuidelines.restoreFocus()
                    }
                    style {
                        flex(1)
                    }
                }) {
                    Text("通知を受け取る")
                }

                Button({
                    classes(AppStyleSheet.secondaryButton)
                    onClick {
                        onLater()
                        AccessibilityGuidelines.releaseFocus()
                        AccessibilityGuidelines.restoreFocus()
                    }
                    style {
                        flex(1)
                    }
                }) {
                    Text("後で")
                }
            }
        }
    }
}
